import styled from '@emotion/styled'
import { space, SpaceProps } from 'styled-system'

export const FormItem = styled.div<SpaceProps>`
  // this uses optional chanining because in the RTL tests, there is
  // no theme provider, so the theme is not set
  margin-bottom: ${props => props.theme?.space?.[5]}px;
  ${space}
`
